var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeletefolder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 135,
    viewBox: "0 0 126 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.938 91.6516C118.371 89.8545 119.492 89.4121 121.528 90.4331C121.809 90.5743 121.931 90.8328 122.238 90.6429C122.506 90.4771 122.677 90.4001 122.984 90.3895",
    stroke: "#FB7C51",
    strokeWidth: 1.44738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.583 10.2406C113.666 35.9491 115.742 88.2011 115.382 91.5405L119.654 104.56L123.195 91.2716L122.078 9.91378C117.724 -6.09688 113.934 3.46057 112.583 10.2406Z",
    stroke: "#FB7C51",
    strokeWidth: 1.44738
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.463 10.7988C115.543 11.7091 118.779 11.3393 121.951 11.2301",
    stroke: "#FB7C51",
    strokeWidth: 1.44738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.59 12.0527C115.202 29.8221 116.191 47.556 116.803 65.3236C116.887 67.7698 116.971 70.2161 117.055 72.6623C117.105 74.1062 117.155 75.5501 117.204 76.9939C117.251 78.3633 117.643 79.6068 117.72 80.9762C117.894 84.0437 118.332 93.2504 118.227 90.1797",
    stroke: "#FB7C51",
    strokeWidth: 1.44738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.618 11.9492C118.801 14.0602 118.541 16.759 118.622 19.1146C118.711 21.6869 118.8 24.2593 118.888 26.8317C119.013 30.4625 119.138 34.0932 119.263 37.724C119.424 42.3956 119.585 47.0673 119.746 51.7389C119.789 52.9924 120.018 54.4578 119.755 55.6859C119.504 56.8614 119.197 57.8175 119.239 59.03C119.293 60.607 119.347 62.1841 119.401 63.7612C119.493 66.4247 119.585 69.0882 119.677 71.7517C119.782 74.8017 119.857 78.1215 120.419 81.0945C120.744 82.8115 120.871 84.4443 120.932 86.2031C120.954 86.8503 120.678 89.9984 121.261 90.2654",
    stroke: "#FB7C51",
    strokeWidth: 1.44738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39695 49.8843C5.27917 43.7611 3.28901 37.6793 1.85657 31.3734C0.583226 25.7679 0.740064 24.2216 7.44373 22.5003C24.7704 18.0514 42.779 15.9311 60.2001 11.6885C63.401 10.909 66.5965 10.1554 69.837 9.54175C70.3779 9.43933 72.635 8.7248 73.2882 9.24593C76.4503 11.7689 76.1722 18.295 76.7216 21.6794C77.8758 28.7891 81.2437 35.1981 83.1508 42.1168C86.1879 53.1343 89.0593 64.2221 91.6171 75.3499C93.7044 84.4309 95.7891 93.4252 97.0423 102.657C97.4927 105.975 97.943 109.293 98.3934 112.611C98.6239 114.309 99.4288 116.728 99.0819 118.486C98.8198 119.814 92.1361 121.001 91.1637 121.238C81.5522 123.58 71.652 125.219 61.9198 127.033C54.1223 128.487 46.3875 129.832 38.5239 130.9C35.0205 131.375 31.7165 132.006 28.2686 132.711C26.3152 133.111 24.3796 133.897 23.6988 131.999C21.2366 125.136 21.13 118.501 20.1682 111.415C19.7046 108 19.2411 104.586 18.7775 101.171C18.3323 97.8907 16.9632 95.0384 16.5115 91.7113C15.5777 84.832 15.2141 77.5275 13.4301 70.8195C12.025 65.5364 10.3378 60.6326 8.64831 55.4859",
    stroke: "#FB7C51",
    strokeWidth: 1.44738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08541 53.5777C9.99281 50.0203 10.4848 45.8501 12.2139 42.2594C14.0237 38.5011 16.9851 45.0539 17.9189 46.6069C18.556 47.6664 21.4464 53.9063 23.2662 53.926C24.2724 53.9369 24.2783 50.0919 25.8658 49.693C27.7476 49.2202 29.1783 48.6362 30.8306 47.5796C32.2816 46.6516 35.3748 46.2302 37.0778 46.2147C40.7065 46.1817 43.2136 44.1668 46.6481 43.4164",
    stroke: "#FB7C51",
    strokeWidth: 1.44738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.574 93.0738C34.574 83.0375 34.574 73.0012 34.574 62.9649C34.574 62.4866 34.5874 61.0589 34.6551 61.5324C35.2126 65.4353 35.9161 69.3195 36.7092 73.1814C37.5881 77.4616 37.8291 77.4084 41.0336 75.4247C42.7656 74.3525 43.498 77.8933 45.1148 77.9923C46.9474 78.1045 48.3822 76.8757 49.6555 75.776C50.2505 75.2622 51.5631 75.608 52.2772 75.5328C53.4674 75.4075 53.3757 74.7646 54.8448 75.1003C57.4584 75.6977 58.6977 75.065 60.3585 73.1273",
    stroke: "#FB7C51",
    strokeWidth: 1.44738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2848 104.699C49.4895 99.3984 65.2956 98.9872 80.0331 95.5195",
    stroke: "#FB7C51",
    strokeWidth: 1.44738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9023 108.141C39.7642 107.651 44.5984 106.896 49.436 106.229",
    stroke: "#FB7C51",
    strokeWidth: 1.44738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2848 112.346C47.7887 110.569 60.4509 108.686 72.7663 105.844",
    stroke: "#FB7C51",
    strokeWidth: 1.44738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0502 119.617C44.059 117.514 52.3038 117.445 60.1454 114.645",
    stroke: "#FB7C51",
    strokeWidth: 1.44738,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletefolder);
export default __webpack_public_path__ + "static/media/deletefolder.3be52dd0f8bbb312442ff92f4773fc37.svg";
export { ForwardRef as ReactComponent };